import { isCpqAppPath } from '../../utils/isCpqAppPath';
import { isSalesforceHost } from '../../utils/isSalesforceHost';

const EMBEDDED_ZUORA_HOSTS = [
  'embedded.stg.na.zuora.com',
  'embedded.preprod.zuora.com',
  'embedded.zuora.com',
  'embedded-sandbox.zuora.com',
];

export function getAgentName(): string {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  // Salesforce and embedded domains should use sales-agent (CPQ integration)
  const isEmbeddedZuoraHost = EMBEDDED_ZUORA_HOSTS.some(
    (allowedHost) =>
      hostname === allowedHost || hostname.endsWith(`.${allowedHost}`),
  );
  if (isSalesforceHost(hostname) || isEmbeddedZuoraHost) {
    return 'sales-agent';
  }

  if (isCpqAppPath(pathname)) {
    return 'sales-agent';
  }
  // Default to orchestrator for all other paths
  return 'orchestrator';
}
